export default "__VITE_ASSET__960b3d61__"